// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { t } from 'Src/i18n';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Slider } from 'Components/frameworks/slider/Slider';
import { ThematicCard } from './ThematicCard';

type ThematicLineItem = {
  mediaUrl: string,
  link?: string,
  itemTitle: string,
  isExclusiveCollection: boolean,
};

type Props = { title?: string, items: Array<ThematicLineItem> };

export const ThematicLine = ({ title, items }: Props) => {
  // use isDesktop to display slider's controls only on desktops
  const { isTablet, isDesktop } = useContext(ResponsiveContext);
  return (
    <SiteContainer className="Line" id="thematic">
      <div className="flex flex-wrap justify-between">
        {!!title && <LineTitle>{title}</LineTitle>}
        <div className="-mx-5 lg:m-0 w-screen lg:w-full">
          <Slider
            cols={0}
            hasControls={isDesktop}
            nbItemsToScroll={isTablet ? 2 : 1}
            scrollAreaClassName="overflow-hidden"
            scrollAreaContainerClassName="overflow-auto scroll-snap-area scroll-snap-type-x-mandatory"
            scrollBackwardLabel={t('common.scrollBackward')}
            scrollForwardLabel={t('common.scrollForward')}
            scrollItemClassName="overflow-hidden flex-none max-w-full"
            navPosition="center"
            scrollControlsClassName="-mx-5 lg:mx-0"
          >
            {items.map(({ itemTitle, mediaUrl, isExclusiveCollection, link }, index) => (
              <ThematicCard
                itemTitle={itemTitle}
                mediaUrl={mediaUrl}
                link={link}
                isExclusiveCollection={isExclusiveCollection}
                isFirst={index === 0}
                key={itemTitle}
              />
            ))}
          </Slider>
        </div>
      </div>
    </SiteContainer>
  );
};
